import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { IoMdCheckmark } from 'react-icons/io';

import { format } from 'legacy/common/utils/datetime';
import { GuestEntryListItem } from 'legacy/events/types';
import UserImage from 'legacy/user/components/UserImage';

interface ManageEntryRowProps {
  entry: GuestEntryListItem;
  onClick: () => void;
  onClickThreeDots: () => void;
}

const ManageEntryRow: React.FC<ManageEntryRowProps> = ({
  entry,
  onClick,
  onClickThreeDots
}) => (
  <div className="flex w-full justify-between px-4 pt-4">
    <div className="flex items-center cursor-pointer" onClick={onClick}>
      <div className="relative  mr-4">
        <UserImage
          src={entry?.user?.photoUrl}
          className="rounded-full w-10 h-10"
        />
        {entry?.isScanned && (
          <div className="absolute top-0 left-0 bg-green-800 bg-opacity-75 w-full h-full rounded-full flex items-center justify-center">
            <IoMdCheckmark className="text-white text-2xl" />
          </div>
        )}
      </div>
      <div>
        <div className="text-base font-bold">
          {entry.type === 'complimentary'
            ? entry?.name
            : `${entry?.user?.firstName} ${entry?.user?.lastName}`}
        </div>
        <div className="text-sm  text-gray-500 font-normal">
          {entry?.tier?.name}
        </div>
        <div className="text-sm  text-gray-500 font-normal">
          {entry?.isScanned
            ? `Scanned on ${format(entry?.scanDate, 'YYYY/MM/DD @ hh:mma')}`
            : 'Not Scanned'}
        </div>
      </div>
    </div>

    <div
      className="text-gray-700 text-2xl flex justify-center items-center cursor-pointer"
      onClick={onClickThreeDots}
    >
      <BsThreeDots />
    </div>
  </div>
);

export default ManageEntryRow;
